import React, { useEffect } from 'react';
import { CheckCircleIcon, ClipboardCheckIcon, MessageCircleIcon, CarIcon, StarIcon, PhoneIcon } from 'lucide-react';
import FacebookPixel from '../components/tracking/FacebookPixel';
import { track } from '../components/tracking/metaPixel';
import { getWhatsAppLink } from '../utils/whatsappLink';
const ThankYou = () => {
  const whatsappLink = getWhatsAppLink('Hola Pedro, acabo de enviar mi solicitud y quiero respuesta urgente.');
  useEffect(() => {
    // Registrar el evento de conversión Lead en la página de agradecimiento
    track('Lead', {
      content_name: 'Formulario Auto',
      status: 'complete'
    });
    // También registrar evento Purchase para conversiones de alto valor
    if (window.fbq) {
      window.fbq('track', 'Purchase', {
        value: 1.0,
        currency: 'USD',
        content_name: 'Lead Completo',
        content_type: 'product',
        content_ids: ['auto_lead']
      });
      console.log('Evento Purchase disparado correctamente');
    } else {
      console.error('Error: fbq no está disponible para el evento Purchase');
    }
  }, []);
  const steps = [{
    icon: <ClipboardCheckIcon className="w-8 h-8 text-primary" data-id="element-428" />,
    title: '1. Revisión',
    description: 'Pedro revisa tu solicitud personalmente.'
  }, {
    icon: <MessageCircleIcon className="w-8 h-8 text-primary" data-id="element-429" />,
    title: '2. Contacto',
    description: 'Te contacta por WhatsApp o llamada en minutos.'
  }, {
    icon: <CarIcon className="w-8 h-8 text-primary" data-id="element-430" />,
    title: '3. Opciones',
    description: 'Te presenta las mejores opciones para ti.'
  }];
  return <div className="font-sans text-dark bg-gray-50 min-h-screen w-full flex flex-col" data-id="element-431">
      <FacebookPixel data-id="element-432" />

      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center p-4" data-id="element-433">
        <div className="w-full max-w-3xl bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100" data-id="element-434">
          {/* Success Header */}
          <div className="bg-primary p-8 md:p-12 text-center relative overflow-hidden" data-id="element-435">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] pointer-events-none" data-id="element-436"></div>

            <div className="relative z-10 flex flex-col items-center" data-id="element-437">
              <div className="bg-white rounded-full p-4 mb-6 shadow-lg animate-bounce-slow" data-id="element-438">
                <CheckCircleIcon className="w-16 h-16 text-[#25D366]" data-id="element-439" />
              </div>
              <h1 className="font-heading font-bold text-3xl md:text-4xl text-white mb-4" data-id="element-440">
                ¡Gracias, tu solicitud fue recibida!
              </h1>
              <p className="text-gray-300 text-lg max-w-xl mx-auto" data-id="element-441">
                Pedro te contactará personalmente en los próximos minutos por
                WhatsApp o llamada.
              </p>
            </div>
          </div>

          {/* Next Steps Section */}
          <div className="p-8 md:p-12" data-id="element-442">
            <h2 className="text-center font-heading font-semibold text-xl text-primary mb-8 uppercase tracking-wide" data-id="element-443">
              ¿Qué pasa ahora?
            </h2>

            <div className="grid md:grid-cols-3 gap-8 mb-12 relative" data-id="element-444">
              {/* Connecting Line (Desktop) */}
              <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-gray-100 -z-10" data-id="element-445"></div>

              {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center bg-white" data-id="element-446">
                  <div className="bg-gray-50 p-4 rounded-full border border-gray-100 mb-4 shadow-sm" data-id="element-447">
                    {step.icon}
                  </div>
                  <h3 className="font-bold text-lg text-primary mb-2" data-id="element-448">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-449">{step.description}</p>
                </div>)}
            </div>

            {/* Trust Reinforcement */}
            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100 text-center mb-8" data-id="element-450">
              <div className="flex justify-center gap-1 mb-3" data-id="element-451">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#FFD700] fill-[#FFD700]" data-id="element-452" />)}
              </div>
              <p className="font-medium text-primary mb-1" data-id="element-453">
                "En 2 horas ya estaba manejando. Pedro me resolvió todo."
              </p>
              <p className="text-sm text-gray-500" data-id="element-454">
                — Jorge, Hialeah (Uno de las 500+ familias ayudadas)
              </p>
            </div>

            {/* Secondary CTA */}
            <div className="text-center border-t border-gray-100 pt-8" data-id="element-455">
              <p className="text-gray-500 text-sm mb-3" data-id="element-456">
                ¿Necesitas respuesta urgente?
              </p>
              <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-primary font-semibold hover:text-secondary transition-colors" data-id="element-457">
                <MessageCircleIcon className="w-4 h-4" data-id="element-458" />
                Escribir directo al WhatsApp
              </a>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 text-center text-gray-400 text-sm" data-id="element-459">
        <div className="container mx-auto" data-id="element-460">
          <p data-id="element-461">
            © {new Date().getFullYear()} Pedro de la Cruz — Fleet Manager,
            Miami
          </p>
        </div>
      </footer>
    </div>;
};
export default ThankYou;